import { h, Component } from 'preact';
import { Text } from 'preact-i18n';

import ArticlePicker from './articlePicker';

class BlockEditor extends Component {
    handleField = (e) => {
        const { name, value } = e.target;
        const { block, onChange } = this.props;
        onChange(block.uuidv4, name, value);
    }

    handleRowField = (e) => {
        const { block, onChange } = this.props;
        const idx = parseInt(e.target.dataset.idx, 10);
        const key = e.target.dataset.key;
        const rows = Array.isArray(block.rows) ? block.rows.map(r => ({ ...r })) : [];
        if (!rows[idx]) {
            rows[idx] = {};
        }
        rows[idx][key] = e.target.value;
        onChange(block.uuidv4, 'rows', rows);
    }

    addRow = () => {
        const { block, onChange } = this.props;
        const rows = (Array.isArray(block.rows) ? block.rows.map(r => ({ ...r })) : []).concat([{ title: '', text: '' }]);
        onChange(block.uuidv4, 'rows', rows);
    }

    removeRow = (e) => {
        const { block, onChange } = this.props;
        const idx = parseInt(e.currentTarget.dataset.idx, 10);
        const rows = (Array.isArray(block.rows) ? block.rows.map(r => ({ ...r })) : []).filter((_, i) => i !== idx);
        onChange(block.uuidv4, 'rows', rows);
    }

    pickArticle = (article) => {
        const { block, onPickArticle } = this.props;
        onPickArticle(block.uuidv4, article);
    }

    // Open the shared image browser (searches uploaded images already in the DB) and store
    // the chosen image's absolute URL on this block.
    browseImage = () => {
        const { appState, userStore } = this.props.stores;
        const { block, onChange } = this.props;
        const level = appState.getTopMostDrawer() + 1;
        appState.openDrawer('imageBrowser', {
            userId: userStore && userStore.user ? userStore.user.id : undefined,
            onSelect: (image) => {
                const url = (image && (image.s3LargeLink || image.s3MediumLink || image.s3Link)) || '';
                onChange(block.uuidv4, 'imageUrl', url);
                appState.toggleDrawer(false, level);
            },
        }, level);
    }

    renderFields() {
        const { block } = this.props;
        switch (block.type) {
            case 'hero':
                return (
                    <div class='d-flex flex-column gap-2'>
                        <input class='form-control' name='headline' value={block.headline || ''} onInput={this.handleField} placeholder='Overskrift' />
                        <input class='form-control' name='subtext' value={block.subtext || ''} onInput={this.handleField} placeholder='Undertekst' />
                        <input class='form-control' name='imageUrl' value={block.imageUrl || ''} onInput={this.handleField} placeholder='Bilde-URL (valgfritt)' />
                        <input class='form-control' name='bgColor' value={block.bgColor || ''} onInput={this.handleField} placeholder='Bakgrunnsfarge (#hex, valgfritt)' />
                    </div>
                );
            case 'text':
                return (
                    <textarea class='form-control' name='markdown' rows='4' value={block.markdown || ''} onInput={this.handleField} placeholder='Tekst (markdown støttes)' />
                );
            case 'article':
                return (
                    <div class='d-flex flex-column gap-2'>
                        {!!block.title && (
                            <div class='alert alert-secondary py-2 mb-1'>
                                <strong>{block.title}</strong>
                                {!!block.ingress && <small class='d-block text-body-secondary'>{block.ingress}</small>}
                            </div>
                        )}
                        <input class='form-control' name='ctaLabel' value={block.ctaLabel || ''} onInput={this.handleField} placeholder='Knappetekst (standard: Les mer)' />
                        {!!block.imageUrl && (
                            <select class='form-select' name='imageAlign' value={block.imageAlign || 'top'} onChange={this.handleField}>
                                <option value='top'>Bilde øverst</option>
                                <option value='left'>Bilde til venstre</option>
                                <option value='right'>Bilde til høyre</option>
                            </select>
                        )}
                        <ArticlePicker
                            stores={this.props.stores}
                            category={['newsletter', 'help']}
                            hasSelection={!!(block.articleId || block.title)}
                            onPick={this.pickArticle}
                        />
                    </div>
                );
            case 'image':
                return (
                    <div class='d-flex flex-column gap-2'>
                        {!!block.imageUrl && (
                            <img src={block.imageUrl} alt='' class='align-self-start rounded' style='max-height:120px;width:auto;' />
                        )}
                        <button type='button' class='btn btn-sm btn-outline-primary rounded-pill align-self-start' onClick={this.browseImage}>
                            <i class='fa-solid fa-images me-1' /> <Text id='newsletter.choose-image'>Choose image</Text>
                        </button>
                        <input class='form-control' name='linkUrl' value={block.linkUrl || ''} onInput={this.handleField} placeholder='Lenke-URL (valgfritt)' />
                    </div>
                );
            case 'button':
                return (
                    <div class='d-flex flex-column gap-2'>
                        <input class='form-control' name='label' value={block.label || ''} onInput={this.handleField} placeholder='Knappetekst' />
                        <input class='form-control' name='url' value={block.url || ''} onInput={this.handleField} placeholder='URL' />
                    </div>
                );
            case 'divider':
                return (
                    <select class='form-select' name='style' value={block.style || 'line'} onChange={this.handleField}>
                        <option value='line'>Linje</option>
                        <option value='space'>Mellomrom</option>
                    </select>
                );
            case 'highlight':
                return (
                    <div class='d-flex flex-column gap-2'>
                        <input class='form-control' name='heading' value={block.heading || ''} onInput={this.handleField} placeholder='Overskrift' />
                        <input class='form-control' name='bgColor' value={block.bgColor || ''} onInput={this.handleField} placeholder='Bakgrunnsfarge (#hex, valgfritt)' />
                        {(Array.isArray(block.rows) ? block.rows : []).map((row, idx) => (
                            <div key={idx} class='d-flex flex-row gap-2 align-items-start'>
                                <div class='d-flex flex-column gap-1 flex-grow-1'>
                                    <input class='form-control form-control-sm' data-idx={idx} data-key='title' value={row.title || ''} onInput={this.handleRowField} placeholder='Rad-tittel' />
                                    <input class='form-control form-control-sm' data-idx={idx} data-key='text' value={row.text || ''} onInput={this.handleRowField} placeholder='Rad-tekst' />
                                </div>
                                <button type='button' class='btn btn-sm btn-outline-danger' data-idx={idx} onClick={this.removeRow}>
                                    <i class='fa-solid fa-times' />
                                </button>
                            </div>
                        ))}
                        <button type='button' class='btn btn-sm btn-outline-secondary rounded-pill' onClick={this.addRow}>
                            <i class='fa-solid fa-plus me-1' /> <Text id='newsletter.add-row'>Add row</Text>
                        </button>
                    </div>
                );
            default:
                return null;
        }
    }

    render() {
        const {
            block, index, total, onRemove, onMoveUp, onMoveDown,
        } = this.props;
        return (
            <div class='card mb-2'>
                <div class='card-header d-flex flex-row justify-content-between align-items-center py-1'>
                    <span class='badge text-bg-secondary text-uppercase'>{block.type}</span>
                    <div class='btn-group btn-group-sm'>
                        <button type='button' class='btn btn-outline-secondary' disabled={index === 0} onClick={() => onMoveUp(block.uuidv4)}>
                            <i class='fa-solid fa-arrow-up' />
                        </button>
                        <button type='button' class='btn btn-outline-secondary' disabled={index === total - 1} onClick={() => onMoveDown(block.uuidv4)}>
                            <i class='fa-solid fa-arrow-down' />
                        </button>
                        <button type='button' class='btn btn-outline-danger' onClick={() => onRemove(block.uuidv4)}>
                            <i class='fa-solid fa-trash' />
                        </button>
                    </div>
                </div>
                <div class='card-body py-2'>
                    {this.renderFields()}
                </div>
            </div>
        );
    }
}

export default BlockEditor;
